import { showError } from "../components/ErrorPopup";
import React, { useEffect, useState } from "react";
// import { FiTrash2 } from "react-icons/fi"; // Import icons from react-icons
import FormAccessManager from "../components/FormAccessManager";
import AdministratorsManager from "../components/AdministratorsManager";
import { io } from "socket.io-client";
import { getBackendToken } from "../utils/authUtils";
import { apiFetch } from '../utils/apiClient';
import {
  ChevronDown,
  Route,
  Search,
  ShieldCheck,
  UserCog,
} from "lucide-react";

const socket = io.connect(`${process.env.REACT_APP_API_BASE_URL}`); // Adapter l'URL si nécessaire

function GroupRoles({ user: currentUser, routesConfig, setRoutesConfig }) {
  const [activeTab, setActiveTab] = useState("formManagement");
  const [roles, setRoles] = useState({});
  const [routesOuvertes, setRoutesOuvertes] = useState(false);
  const [rechercheRoute, setRechercheRoute] = useState("");
  const [filtreRoute, setFiltreRoute] = useState("toutes");

  useEffect(() => {
    
    // socket.emit("getAllRoles")
    const fetchRolesWithAuth = async () => {
    const token = await getBackendToken(); // récupère le token backend
    socket.emit("getAllRoles", { token });
  };

  fetchRolesWithAuth();

    socket.on("updateRoles", (data) => {
      setRoles(data);
    });
  
    socket.on("error", (err) => {
      console.error("Error from server:", err);
    });
  
    socket.on("disconnect", () => {
      console.log("Disconnected from socket server");
    });
  
    return () => {
      socket.off("updateRoles");
      socket.off("error");
      socket.off("connect");
      socket.off("disconnect");
    };
  }, []);
  

  

  const handleRoleDeleted = (userId, group) => {
    setRoles((rolesActuels) =>
      Array.isArray(rolesActuels)
        ? rolesActuels.filter(
            (role) => !(role.userId === userId && role.group === group),
          )
        : [],
    );
  };

  const handleProcessingRoleAdded = async (memberData) => {
    const userExists =
      Array.isArray(roles) &&
      roles.some(
        (role) =>
          role.userId === memberData.userId && role.group === memberData.group,
      );

    if (userExists) {
      throw new Error("Cette personne est déjà membre du groupe de traitement.");
    }

    const response = await apiFetch(
      `${process.env.REACT_APP_API_BASE_URL}/addRole`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(memberData),
      },
    );
    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.error || data.message || "Impossible d'ajouter ce membre.");
    }

    setRoles((rolesActuels) => {
      const listeActuelle = Array.isArray(rolesActuels) ? rolesActuels : [];
      const dejaAjoute = listeActuelle.some(
        (role) =>
          role.userId === memberData.userId && role.group === memberData.group,
      );
      return dejaAjoute ? listeActuelle : [...listeActuelle, memberData];
    });
  };

  const toggleRoute = async (route) => {
  // basculer enabled en local
  const updated = { ...route, enabled: !route.enabled };

  setRoutesConfig(prev =>
    prev.map(r =>
      r.path === route.path ? updated : r
    )
  );

  try {
    // envoyer la mise à jour au backend
    const response = await apiFetch(`${process.env.REACT_APP_API_BASE_URL}/routeUpdate`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        path: updated.path,
        enabled: updated.enabled,
        label: updated.label, // 🔹 si tu veux stocker aussi le label
      }),
    });
    
    const data = await response.json();
          if (!response.ok) {
            throw new Error(data.error || data.message);
          }
  } catch (error) {
        console.error(error);
        showError(error); // ou setError(error.message)
      }
};

  const routes = Array.isArray(routesConfig) ? routesConfig : [];
  const nombreRoutesActivees = routes.filter((route) => route.enabled).length;
  const nombreRoutesDesactivees = routes.length - nombreRoutesActivees;
  const rechercheNormalisee = rechercheRoute.trim().toLocaleLowerCase("fr-CA");
  const routesFiltrees = routes.filter((route) => {
    const correspondAuFiltre =
      filtreRoute === "toutes" ||
      (filtreRoute === "activees" && route.enabled) ||
      (filtreRoute === "desactivees" && !route.enabled);
    const correspondARecherche =
      !rechercheNormalisee ||
      route.label?.toLocaleLowerCase("fr-CA").includes(rechercheNormalisee) ||
      route.path?.toLocaleLowerCase("fr-CA").includes(rechercheNormalisee);

    return correspondAuFiltre && correspondARecherche;
  });
  return (
    <div className="min-h-screen overflow-auto bg-gray-100 px-4 pb-10 pt-6 sm:p-8">
      <header className="mb-7">
        <h1 className="text-2xl font-bold tracking-tight text-slate-900 sm:text-3xl">
          Gestion des groupes et des accès
        </h1>
        <p className="mt-2 text-sm text-slate-600 sm:text-base">
          Configurez les accès, les groupes de traitement et les routes de
          l’application.
        </p>
      </header>
      <div className="min-h-screen bg-gray-100 sm:p-6">
        <div
          className="mb-6 overflow-x-auto border-b border-slate-300"
          role="tablist"
          aria-label="Sections de gestion"
        >
          <div className="flex min-w-max items-end gap-1" role="presentation">
            {[
              {
                key: "formManagement",
                label: "Gestion des formulaires",
                icon: ShieldCheck,
              },
              {
                key: "administrators",
                label: "Administrateurs",
                icon: UserCog,
              },
              {
                key: "routes",
                label: "Gestion des routes",
                icon: Route,
              },
            ].map((tab) => {
              const Icon = tab.icon;
              const selected = activeTab === tab.key;

              return (
                <button
                  key={tab.key}
                  type="button"
                  role="tab"
                  aria-selected={selected}
                  onClick={() => {
                    setActiveTab(tab.key);
                    if (tab.key === "routes") {
                      setRoutesOuvertes(true);
                    }
                  }}
                  className={`relative inline-flex min-h-12 flex-none items-center gap-2 whitespace-nowrap border-b-2 px-4 py-3 text-sm font-semibold transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-blue-500 sm:px-5 ${
                    selected
                      ? "border-blue-700 bg-blue-50/70 text-blue-800"
                      : "border-transparent text-slate-600 hover:border-slate-300 hover:bg-white/70 hover:text-slate-900"
                  }`}
                >
                  <Icon className="h-4 w-4" aria-hidden="true" />
                  {tab.label}
                </button>
              );
            })}
          </div>
        </div>

        {/* Gestion des routes */}
        {activeTab === "routes" && (
        <section className="mb-10 overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm">
          <button
            type="button"
            onClick={() => setRoutesOuvertes((ouvertes) => !ouvertes)}
            className="flex w-full items-center justify-between gap-4 px-4 py-4 text-left transition-colors hover:bg-slate-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-blue-500 sm:px-6"
            aria-expanded={routesOuvertes}
            aria-controls="gestion-routes-content"
          >
            <span className="flex min-w-0 items-start gap-3">
              <span className="inline-flex h-10 w-10 flex-none items-center justify-center rounded-lg bg-blue-50 text-blue-700">
                <Route className="h-5 w-5" aria-hidden="true" />
              </span>
              <span className="min-w-0">
                <span className="block text-base font-semibold text-slate-900 sm:text-lg">
                  Gestion des routes
                </span>
                <span className="mt-1 flex flex-wrap gap-x-3 gap-y-1 text-xs text-slate-500 sm:text-sm">
                  <span>{routes.length} route(s)</span>
                  <span className="text-emerald-700">
                    {nombreRoutesActivees} activée(s)
                  </span>
                  <span className="text-red-700">
                    {nombreRoutesDesactivees} désactivée(s)
                  </span>
                </span>
              </span>
            </span>

            <span className="flex flex-none items-center gap-2 text-sm font-semibold text-slate-700">
              <span className="hidden sm:inline">
                {routesOuvertes ? "Réduire" : "Gérer les routes"}
              </span>
              <ChevronDown
                className={`h-5 w-5 transition-transform duration-200 ${
                  routesOuvertes ? "rotate-180" : ""
                }`}
                aria-hidden="true"
              />
            </span>
          </button>

          {routesOuvertes && (
            <div
              id="gestion-routes-content"
              className="border-t border-slate-200 bg-slate-50/70 px-4 py-4 sm:px-6 sm:py-5"
            >
              <div className="flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between">
                <div className="relative w-full lg:max-w-md">
                  <Search
                    className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400"
                    aria-hidden="true"
                  />
                  <input
                    type="search"
                    value={rechercheRoute}
                    onChange={(event) => setRechercheRoute(event.target.value)}
                    placeholder="Rechercher une route..."
                    className="min-h-11 w-full rounded-lg border border-slate-300 bg-white py-2 pl-9 pr-3 text-sm text-slate-800 shadow-sm outline-none transition focus:border-blue-500 focus:ring-2 focus:ring-blue-100"
                  />
                </div>

                <div
                  className="grid grid-cols-3 gap-1 rounded-lg border border-slate-200 bg-white p-1"
                  aria-label="Filtrer les routes"
                >
                  {[
                    { value: "toutes", label: "Toutes" },
                    { value: "activees", label: "Activées" },
                    { value: "desactivees", label: "Désactivées" },
                  ].map((filtre) => (
                    <button
                      key={filtre.value}
                      type="button"
                      onClick={() => setFiltreRoute(filtre.value)}
                      className={`min-h-9 rounded-md px-2 py-1.5 text-xs font-semibold transition-colors sm:px-3 sm:text-sm ${
                        filtreRoute === filtre.value
                          ? "bg-slate-800 text-white"
                          : "text-slate-600 hover:bg-slate-100"
                      }`}
                      aria-pressed={filtreRoute === filtre.value}
                    >
                      {filtre.label}
                    </button>
                  ))}
                </div>
              </div>

              <div className="mt-4 overflow-hidden rounded-lg border border-slate-200 bg-white">
                {routesFiltrees.length > 0 ? (
                  <div className="divide-y divide-slate-200">
                    {routesFiltrees.map((routeConfig) => (
                      <div
                        key={routeConfig.path}
                        className="flex flex-col gap-3 px-4 py-3.5 transition-colors hover:bg-slate-50 sm:flex-row sm:items-center sm:justify-between sm:gap-5"
                      >
                        <div className="min-w-0">
                          <h3 className="text-sm font-semibold text-slate-900 sm:text-[15px]">
                            {routeConfig.label}
                          </h3>
                          <p className="mt-1 break-all text-xs text-slate-500">
                            {routeConfig.path}
                          </p>
                        </div>

                        <button
                          type="button"
                          role="switch"
                          aria-checked={routeConfig.enabled}
                          aria-label={`${routeConfig.label} : ${
                            routeConfig.enabled ? "activée" : "désactivée"
                          }`}
                          onClick={() => toggleRoute(routeConfig)}
                          className="inline-flex min-h-10 flex-none items-center justify-between gap-3 self-stretch rounded-lg border border-slate-200 bg-white px-3 text-sm font-semibold text-slate-700 transition-colors hover:bg-slate-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 sm:self-auto"
                        >
                          <span>
                            {routeConfig.enabled ? "Activée" : "Désactivée"}
                          </span>
                          <span
                            className={`relative inline-flex h-6 w-11 flex-none rounded-full transition-colors ${
                              routeConfig.enabled ? "bg-emerald-600" : "bg-slate-300"
                            }`}
                            aria-hidden="true"
                          >
                            <span
                              className={`absolute top-0.5 h-5 w-5 rounded-full bg-white shadow-sm transition-transform ${
                                routeConfig.enabled
                                  ? "translate-x-[1.375rem]"
                                  : "translate-x-0.5"
                              }`}
                            />
                          </span>
                        </button>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="px-4 py-10 text-center">
                    <p className="text-sm font-medium text-slate-700">
                      Aucune route trouvée
                    </p>
                    <p className="mt-1 text-xs text-slate-500">
                      Modifiez la recherche ou le filtre sélectionné.
                    </p>
                  </div>
                )}
              </div>
            </div>
          )}
        </section>
        )}

        {activeTab === "formManagement" && (
          <FormAccessManager
            defaultOpen
            processingRoles={Array.isArray(roles) ? roles : []}
            onProcessingRoleAdded={handleProcessingRoleAdded}
            onProcessingRoleDeleted={handleRoleDeleted}
          />
        )}

        {activeTab === "administrators" && (
          <AdministratorsManager currentUser={currentUser} />
        )}

        {/* Ancienne interface séparée des groupes retirée de l'affichage.
        <section className="overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm">
          <div className="border-b border-slate-200 px-4 py-4 sm:px-6">
            <div className="flex items-start gap-3">
              <span className="inline-flex h-10 w-10 flex-none items-center justify-center rounded-lg bg-slate-100 text-slate-700">
                <UsersRound className="h-5 w-5" aria-hidden="true" />
              </span>
              <div className="min-w-0">
                <h2 className="text-base font-semibold text-slate-900 sm:text-lg">
                  Groupes généraux
                </h2>
                <p className="mt-1 text-sm text-slate-600">
                  {nombreUtilisateurs} utilisateur(s) réparti(s) dans {nomsGroupes.length} groupe(s) non liés à un formulaire unique
                </p>
              </div>
            </div>

            <div className="mt-4 grid gap-3 md:grid-cols-[minmax(0,1fr)_minmax(14rem,20rem)]">
              <div className="relative min-w-0">
                <Search
                  className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400"
                  aria-hidden="true"
                />
                <input
                  type="search"
                  value={rechercheUtilisateur}
                  onChange={(event) => setRechercheUtilisateur(event.target.value)}
                  placeholder="Rechercher par nom ou courriel..."
                  className="min-h-11 w-full rounded-lg border border-slate-300 bg-white py-2 pl-9 pr-3 text-sm text-slate-800 shadow-sm outline-none transition focus:border-blue-500 focus:ring-2 focus:ring-blue-100"
                />
              </div>

              <select
                value={filtreGroupe}
                onChange={(event) => setFiltreGroupe(event.target.value)}
                className="min-h-11 w-full rounded-lg border border-slate-300 bg-white px-3 py-2.5 text-sm text-slate-800 shadow-sm outline-none transition focus:border-blue-500 focus:ring-2 focus:ring-blue-100"
                aria-label="Filtrer par groupe"
              >
                <option value="tous">Tous les groupes</option>
                {nomsGroupes.map((groupName) => (
                  <option key={groupName} value={groupName}>
                    {groupName}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="bg-white">
            {groupesFiltres.length > 0 ? (
              <div className="divide-y divide-slate-200">
                {groupesFiltres.map(({ groupName, roles: groupRoles }) => {
                  const selectionne = groupeSelectionne === groupName;

                  return (
                    <button
                      key={groupName}
                      type="button"
                      onClick={() => ouvrirDetailsGroupe(groupName)}
                      className={`group flex w-full items-center gap-3 border-l-4 px-4 py-4 text-left transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-blue-500 sm:px-5 ${
                        selectionne
                          ? "border-blue-600 bg-blue-50"
                          : "border-transparent hover:bg-blue-50/60"
                      }`}
                      aria-current={selectionne ? "true" : undefined}
                    >
                      <span className="inline-flex h-9 w-9 flex-none items-center justify-center rounded-lg bg-blue-50 text-blue-700">
                        <UsersRound className="h-4 w-4" aria-hidden="true" />
                      </span>
                      <span className="min-w-0 flex-1">
                        <span className="block break-words text-sm font-semibold text-slate-900 group-hover:text-blue-800">
                          {groupName}
                        </span>
                        <span className="mt-1 block text-xs text-slate-500">
                          {groupRoles.length === 0
                            ? "Aucun membre"
                            : `${groupRoles.length} membre${groupRoles.length > 1 ? "s" : ""}`}
                        </span>
                      </span>
                      <span className="hidden w-20 flex-none text-right text-sm font-semibold text-blue-700 sm:inline">
                        Gérer
                      </span>
                      <ChevronRight className="h-5 w-5 flex-none text-slate-400 transition-transform group-hover:translate-x-0.5 group-hover:text-blue-600" />
                    </button>
                  );
                })}
              </div>
            ) : (
              <div className="px-4 py-12 text-center">
                <p className="text-sm font-semibold text-slate-800">
                  Aucun groupe trouvé
                </p>
                <p className="mt-1 text-sm text-slate-500">
                  Modifiez la recherche ou le filtre sélectionné.
                </p>
              </div>
            )}
          </div>

          {panneauGroupeOuvert && groupeSelectionne && (
            <div
              className="fixed inset-0 z-50 flex justify-end overscroll-none bg-slate-950/45 backdrop-blur-[2px]"
              onMouseDown={(event) => {
                if (event.target === event.currentTarget) fermerDetailsGroupe();
              }}
            >
              <section
                role="dialog"
                aria-modal="true"
                aria-labelledby="processing-group-details-title"
                className="flex h-[100dvh] w-full flex-col overflow-hidden bg-white shadow-2xl sm:h-full sm:max-w-2xl sm:border-l sm:border-slate-200 lg:max-w-3xl"
              >
                <header className="flex flex-none items-start justify-between gap-4 border-b border-slate-200 bg-white px-4 py-4 sm:px-6 sm:py-5">
                  <div className="min-w-0">
                    <h3
                      id="processing-group-details-title"
                      className="break-words text-lg font-semibold text-slate-900 sm:text-xl"
                    >
                      {groupeSelectionne}
                    </h3>
                    <p className="mt-1 text-sm text-slate-500">
                      {rolesGroupeSelectionne.length === 0
                        ? "Aucun membre dans ce groupe"
                        : `${rolesGroupeSelectionne.length} membre${rolesGroupeSelectionne.length > 1 ? "s" : ""} dans ce groupe`}
                    </p>
                  </div>
                  <button
                    type="button"
                    onClick={fermerDetailsGroupe}
                    className="inline-flex h-10 w-10 flex-none items-center justify-center rounded-lg border border-slate-200 text-slate-500 transition-colors hover:bg-slate-100 hover:text-slate-900 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500"
                    aria-label="Fermer le panneau"
                    title="Fermer"
                  >
                    <X className="h-5 w-5" aria-hidden="true" />
                  </button>
                </header>

                <div className="min-h-0 flex-1 overflow-y-auto overscroll-contain bg-slate-50 p-4 sm:p-6">
                  <div className="space-y-4">
                    <div className="flex justify-end">
                      <button
                        type="button"
                        onClick={() =>
                          setAjoutUtilisateurOuvert((ouvert) => !ouvert)
                        }
                        className="inline-flex min-h-11 w-full items-center justify-center gap-2 rounded-lg bg-blue-700 px-4 py-2 text-sm font-semibold text-white transition-colors hover:bg-blue-800 sm:w-auto"
                      >
                        <UserPlus className="h-4 w-4" aria-hidden="true" />
                        Ajouter un utilisateur
                      </button>
                    </div>

                    {ajoutUtilisateurOuvert && (
                      <form
                        onSubmit={handleSubmit}
                        className="overflow-visible rounded-xl border border-blue-200 bg-blue-50/40 p-4 sm:p-5"
                      >
                        <div className="flex items-start justify-between gap-3">
                          <div>
                            <h4 className="text-base font-semibold text-slate-900">
                              Ajouter un membre
                            </h4>
                            <p className="mt-1 text-sm text-slate-600">
                              Recherchez la personne à ajouter à ce groupe.
                            </p>
                          </div>
                          <button
                            type="button"
                            onClick={() => setAjoutUtilisateurOuvert(false)}
                            className="text-sm font-semibold text-slate-600 hover:text-slate-900"
                          >
                            Annuler
                          </button>
                        </div>

                        <div className="mt-4 grid gap-3 lg:grid-cols-[minmax(0,1fr)_auto] lg:items-end">
                          <div className="min-w-0">
                            <label className="mb-1.5 block text-sm font-semibold text-slate-800">
                              Utilisateur
                            </label>
                            <UsersList
                              key={`${groupeSelectionne}-${formData.userId || "vide"}`}
                              onUserSelect={handleUserSelect}
                              initialValue={formData.email}
                              placeholder="Rechercher par nom ou courriel"
                              inputClassName="min-h-11 w-full rounded-lg border border-slate-300 bg-white px-3 py-2.5 text-sm text-slate-800 shadow-sm outline-none transition focus:border-blue-500 focus:ring-2 focus:ring-blue-100"
                            />
                          </div>
                          <button
                            type="submit"
                            disabled={!formData.userId}
                            className="inline-flex min-h-11 w-full items-center justify-center gap-2 rounded-lg bg-blue-700 px-4 py-2 text-sm font-semibold text-white transition-colors hover:bg-blue-800 disabled:cursor-not-allowed disabled:opacity-50 lg:w-auto"
                          >
                            <UserPlus className="h-4 w-4" aria-hidden="true" />
                            Ajouter
                          </button>
                        </div>

                        {nom && (
                          <div className="mt-4 flex items-center gap-3 rounded-lg border border-blue-200 bg-white px-3 py-3">
                            <span className="inline-flex h-10 w-10 flex-none items-center justify-center rounded-full bg-blue-100 text-sm font-bold text-blue-700">
                              {nom
                                .split(/[\s,]+/)
                                .filter(Boolean)
                                .slice(0, 2)
                                .map((partie) => partie.charAt(0).toUpperCase())
                                .join("")}
                            </span>
                            <div className="min-w-0">
                              <p className="break-words text-sm font-semibold text-slate-900">
                                {nom}
                              </p>
                              <p className="break-all text-xs text-slate-600">
                                {formData.email}
                              </p>
                            </div>
                          </div>
                        )}
                      </form>
                    )}

                    <div className="overflow-hidden rounded-xl border border-slate-200 bg-white">
                      <div className="border-b border-slate-200 px-4 py-4 sm:px-5">
                        <h4 className="text-base font-semibold text-slate-900">
                          Membres du groupe
                        </h4>
                        <p className="mt-1 text-sm text-slate-500">
                          Personnes autorisées à traiter les demandes de ce groupe.
                        </p>
                      </div>
                      {rolesGroupeSelectionne.length > 0 ? (
                        <Grouproleschema
                          roles={rolesGroupeSelectionne}
                          groupName={groupeSelectionne}
                          onRoleDeleted={handleRoleDeleted}
                          isOpen
                          onToggle={() => {}}
                          showGroupHeader={false}
                        />
                      ) : (
                        <div className="px-4 py-10 text-center sm:px-5">
                          <p className="text-sm font-semibold text-slate-800">
                            Aucun membre ajouté
                          </p>
                          <p className="mt-1 text-sm text-slate-500">
                            Utilisez le bouton ci-dessus pour ajouter un utilisateur.
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </section>
            </div>
          )}
        </section>
        */}
      </div>

      {/* Group Test Roles */}
      {/* <h2 className="mt-6 text-2xl font-semibold text-blue-600">Group Test Roles</h2>
      <div className="space-y-4 mb-6">
        {roles.listGroupTest.map((role, index) => (
          <div key={`test-${index}`} className="flex flex-col w-1/2 p-4 bg-white border rounded-lg shadow-md transition hover:shadow-lg">
            <div className="flex mb-1">
              <span className="font-semibold text-gray-700">Nom:</span>
              <span className="pl-2 text-gray-600">{role.nom}</span>
            </div>
            <div className="flex mb-1">
              <span className="font-semibold text-gray-700">Email:</span>
              <span className="pl-2 text-gray-600">{role.email}</span>
            </div>
            <button onClick={() => handleDelete(role.userId)} className="text-red-500 hover:text-red-700 transition duration-200 mt-2">
              <FiTrash2 />
            </button>
          </div>
        ))}
      </div> */}

      {/* Group Roles Adresse */}
      {/* <h2 className="mt-6 text-2xl font-semibold text-green-600">Group Roles Adresse</h2>
      <div className="space-y-4 mb-6">
        {roles.listGroupRolesAdresse.map((role, index) => (
          <div key={`adresse-${index}`} className="flex flex-col w-1/2 p-4 bg-white border rounded-lg shadow-md transition hover:shadow-lg">
            <div className="flex mb-1">
              <span className="font-semibold text-gray-700">Nom:</span>
              <span className="pl-2 text-gray-600">{role.nom}</span>
            </div>
            <div className="flex mb-1">
              <span className="font-semibold text-gray-700">Email:</span>
              <span className="pl-2 text-gray-600">{role.email}</span>
            </div>
            <button onClick={() => handleDelete(role.userId)} className="text-red-500 hover:text-red-700 transition duration-200 mt-2">
              <FiTrash2 />
            </button>
          </div>
        ))}
      </div>*/}

      {/* <Grouproleschema roles={roles} groupName={"listGroupTest"}></Grouproleschema>  */}
    </div>
  );
}

export default GroupRoles;
